import React, { useEffect, useState } from "react";
import Form from "@Components/Form";
import { fetchDataFromApi, FormLineBreak } from "../../utils";
import { ERML_SETTINGS_URL } from "../../configs/constants";
import { useTranslation } from "react-i18next";
import eightAxios from "../../configs/axiosConfig";
import { useNotifyContext } from "@Components/Notify";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";

function ERMLSetting() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const setNotify = useNotifyContext();
  const [ERMLSettings, setERMLSettings] = useState({
    file_generate_time: "",
    file_generate_frequency: "",
  });
  const generate_freq = [
    {
      value: "daily",
      key: t("Daily"),
    },
  ];

  useEffect(() => {
    fetchDataFromApi(ERML_SETTINGS_URL, setERMLSettings, false);
  }, []);

  const initialValues = {
    file_generate_time: ERMLSettings.file_generate_time,
    file_generate_frequency: ERMLSettings.file_generate_frequency,
  };

  const handleSubmit = (values, { setSubmitting }) => {
    setLoading(true);
    eightAxios
      .post(ERML_SETTINGS_URL, values)
      .then((response) => {
        setERMLSettings(response.data);
        setNotify({
          isOpen: true,
          message: "Successfully updated.",
          type: "success",
        });
        setLoading(false);
        setSubmitting(false);
      })
      .catch((error) => {
        console.log(error);
        setNotify({
          isOpen: true,
          message: error.response.data.message,
          type: "error",
        });
        setSubmitting(false);
        setLoading(false);
      });
  };
  console.log(ERMLSettings);

  const formFields = [
    {
      type: "radio",
      label: "File Generate Frequency",
      name: "file_generate_frequency",
      options: generate_freq,
      required: true,
    },
    {
      type: "component",
      component: FormLineBreak,
      gridSize: { lg: 12 },
    },
    {
      type: "timepicker",
      name: "file_generate_time",
      autoComplete: "off",
      size: "small",
      helperText: "",
      label: "File Generate Time",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      emptyLabel: "HH:mm:ss",
      required: true,
    },
  ];
  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }
  const formButtons = ["save"];
  return (
    <Form
      initialValues={initialValues}
      listRoute="/attendance/erml/erml-settings"
      outerSubmitHandler={handleSubmit}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="ERML Settings"
      noListButton
      noFeature={true}

    />
  );
}

export default ERMLSetting;
